export default {"positiveValue":"VJ6qT","footer":"e-E7c","footerRow":"btDSt","footerCell":"TgYTd","footerSection":"vs99l","tableHeading":"kvxk0"};